import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';

import { Location } from 'models/locations';
import Event from 'models/event';

import Tooltip from 'components/checkout/event-tooltip/tooltip';

const propTypes = {
  sellers: PropTypes.instanceOf(Map),
  selectedLocation: PropTypes.instanceOf(Location),
  event: PropTypes.instanceOf(Event),
};

const defaultProps = {
  sellers: Map(),
  selectedLocation: null,
  event: null,
};

const CheckoutEventTooltip = ({
  sellers,
  selectedLocation,
  event,
}) => {
  if (!event) return null;

  const seller = sellers.get(selectedLocation.sellerId.toString());

  return (
    <div
      data-for="eventTooltip"
      data-event="click"
      data-tip
      className="margin-top-10 margin-bottom-10 clickable"
    >
      <div className="text-weight-book text-size-12 text-color-dark-slate">
        Parking reservation begins at least one hour before event, and end at least one hour after.
        <span className="iconified-font iconified-info-circle-fill margin-left-5 text-color-bp-blue" />
      </div>
      <Tooltip seller={seller} />
    </div>
  );
};

CheckoutEventTooltip.propTypes = propTypes;
CheckoutEventTooltip.defaultProps = defaultProps;
export default CheckoutEventTooltip;
